/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Import_DescriptionInputs */

const en_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import a project from a file and configure import settings`)
};

const fr_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer un projet depuis un fichier et configurer les paramètres d’importation`)
};

const de_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importieren Sie ein Projekt aus einer Datei und konfigurieren Sie die Importeinstellungen.`)
};

const it_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa un progetto da un file e configura le impostazioni di importazione`)
};

const ru_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортируйте проект из файла и настройте параметры импорта.`)
};

const es_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar un proyecto desde un archivo y configurar los ajustes de importación`)
};

const zh_cn2_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从文件导入项目并配置导入设置`)
};

const ja_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルからプロジェクトをインポートし、インポート設定を構成する`)
};

const hi_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किसी फ़ाइल से प्रोजेक्ट आयात करें और आयात सेटिंग्स कॉन्फ़िगर करें`)
};

const pt_pt2_project_import_description = /** @type {(inputs: Project_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe um projeto a partir de um arquivo e configure as opções de importação.`)
};

/**
* | output |
* | --- |
* | "Import a project from a file and configure import settings" |
*
* @param {Project_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_import_description = /** @type {((inputs?: Project_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_import_description(inputs)
	if (locale === "de") return de_project_import_description(inputs)
	if (locale === "it") return it_project_import_description(inputs)
	if (locale === "ru") return ru_project_import_description(inputs)
	if (locale === "es") return es_project_import_description(inputs)
	if (locale === "zh-CN") return zh_cn2_project_import_description(inputs)
	if (locale === "ja") return ja_project_import_description(inputs)
	if (locale === "hi") return hi_project_import_description(inputs)
	if (locale === "pt-PT") return pt_pt2_project_import_description(inputs)
	return en_project_import_description(inputs)
});